/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiInstitutionItemIdGet } from '../fn/institution/api-institution-item-id-get';
import { ApiInstitutionItemIdGet$Params } from '../fn/institution/api-institution-item-id-get';
import { apiInstitutionOverviewGet } from '../fn/institution/api-institution-overview-get';
import { ApiInstitutionOverviewGet$Params } from '../fn/institution/api-institution-overview-get';
import { apiInstitutionSyncPost } from '../fn/institution/api-institution-sync-post';
import { ApiInstitutionSyncPost$Params } from '../fn/institution/api-institution-sync-post';
import { Institution } from '../models/institution';
import { InstitutionOverviewList } from '../models/institution-overview-list';


/**
 * Institution service
 */
@Injectable({ providedIn: 'root' })
export class InstitutionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiInstitutionItemIdGet()` */
  static readonly ApiInstitutionItemIdGetPath = '/api/institution/{item_id}';

  /**
   * Get institution.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInstitutionItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInstitutionItemIdGet$Response(params: ApiInstitutionItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Institution>> {
    return apiInstitutionItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get institution.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiInstitutionItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInstitutionItemIdGet(params: ApiInstitutionItemIdGet$Params, context?: HttpContext): Observable<Institution> {
    return this.apiInstitutionItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Institution>): Institution => r.body)
    );
  }

  /** Path part for operation `apiInstitutionOverviewGet()` */
  static readonly ApiInstitutionOverviewGetPath = '/api/institution/overview';

  /**
   * Get institution overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInstitutionOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInstitutionOverviewGet$Response(params?: ApiInstitutionOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<InstitutionOverviewList>> {
    return apiInstitutionOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get institution overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiInstitutionOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiInstitutionOverviewGet(params?: ApiInstitutionOverviewGet$Params, context?: HttpContext): Observable<InstitutionOverviewList> {
    return this.apiInstitutionOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<InstitutionOverviewList>): InstitutionOverviewList => r.body)
    );
  }

  /** Path part for operation `apiInstitutionSyncPost()` */
  static readonly ApiInstitutionSyncPostPath = '/api/institution/sync';

  /**
   * Sync institutions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiInstitutionSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiInstitutionSyncPost$Response(params: ApiInstitutionSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiInstitutionSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync institutions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiInstitutionSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiInstitutionSyncPost(params: ApiInstitutionSyncPost$Params, context?: HttpContext): Observable<void> {
    return this.apiInstitutionSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
